import FeaturePreviewBanner from "../../../../features/featureFlags/components/FeaturePreviewBanner";

const ReportsPageLayout = ({ children }: { children: React.ReactNode }) => (
  <div className="flex-1 overflow-auto bg-gray-100">   
    <FeaturePreviewBanner featureName="INTERNAL_REPORTS" /> 
    <div className="w-full max-w-none px-6 py-6">{children}</div>
  </div>
);

export default ReportsPageLayout;
